import React from "react";
import { FaCogs, FaRobot, FaBrain, FaClock, FaLightbulb } from "react-icons/fa";
import "../styles/SobreArc.css";

import { MdOutlineShowChart } from "react-icons/md";
import { BsChatLeftDotsFill } from "react-icons/bs";
import { TbReportMoney } from "react-icons/tb";

function SobreArc() {
  return (
    <section className="sobre-impacto-section" id="sobreNos">
      <div className="sobre-impacto-container">
        <div className="impacto-texto">
          <h2>
            O que é o <span className="destaque">ARC</span>?
          </h2>
          <p>
            O <span className="destaque">ARC</span> é uma plataforma de
            inteligência artificial desenvolvida para transformar a rotina de
            consultórios médicos e odontológicos. Com ele, você acompanha seus
            dados em tempo real, como número de consultas, leads, faturamento e
            metas, tudo de forma simples e visual.
          </p>
          <p>
            Através da integração com sistemas já utilizados na clínica e com o
            suporte da IA, o ARC analisa padrões, gera relatórios e sugere
            estratégias personalizadas para potencializar seus resultados. Tudo
            isso com uma comunicação leve, direta e via WhatsApp.
          </p>
        </div>

        <div className="impacto-cards">
          <div className="impacto-card card1">
            <div className="ia-badge">
              <MdOutlineShowChart className="iconeFloat" />
              <p>Dados em Tempo Real</p>
            </div>
            <TbReportMoney className="impacto-icon" />
            <h3>+28% Faturamento</h3>
            <p>Aumento médio com uso contínuo da inteligência do ARC.</p>
          </div>
          <div className="impacto-card card2">
            <div className="ia-badge">
              <FaClock className="iconeFloat" />
              <p>Com Automação Avançada</p>
            </div>
            <FaCogs className="impacto-icon" />
            <h3>Automação total</h3>
            <p>Agendamentos, relatórios e controle sem esforço humano.</p>
          </div>
          <div className="impacto-card card3">
            <div className="ia-badge">
              <BsChatLeftDotsFill className="iconeFloat" />
              <p>Com Inteligência Artificial</p>
            </div>
            <FaRobot className="impacto-icon" />
            <h3>IA que conversa</h3>
            <p>Receba insights diretamente no WhatsApp em segundos.</p>
          </div>
          <div className="impacto-card card4">
            <div className="ia-badge">
              <FaLightbulb className="iconeFloat" />
              <p>Indicadores Inteligentes</p>
            </div>
            <FaBrain className="impacto-icon" />
            <h3>Estratégia inteligente</h3>
            <p>A IA interpreta seus dados e entrega ações certeiras.</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SobreArc;
